export const videosCurtainAnime = {
  initial: { width: "50%" },
  animate: {
    width: "12%",
    transition: {
      duration: 2,
      delay: 2.1,
      ease: "easeInOut",
    },
  },
};

export const birdMoveAnime = {
  initial: { left: "-6%" },
  animate: {
    left: "100%",
    transition: {
      duration: 30,
      delay: 0,
      ease: "linear",
      repeat: Infinity,
    },
  },
};

export const dogMoveAnime = {
  initial: { left: "100%" },
  animate: {
    left: "-10%",
    transition: {
      duration: 30,
      delay: 0,
      ease: "linear",
      repeat: Infinity,
    },
  },
};

export const cloudMoveAnime1 = {
  initial: { left: "-12%" },
  animate: {
    left: "112%",
    transition: {
      duration: 120,
      delay: 0,
      ease: "linear",
      repeat: Infinity,
    },
  },
};

export const cloudMoveAnime2 = {
  initial: { left: "-13%" },
  animate: {
    left: "114%",
    transition: {
      duration: 150,
      delay: 30,
      ease: "linear",
      repeat: Infinity,
    },
  },
};

export const sentence = {
  initial: { opacity: 1 },
  animate: {
    opacity: 1,
    transition: {
      delay: 3,
      staggerChildren: 0.08,
      delayChildren: 0.2,
      ease: "easeInOut",
      repeat: Infinity,
    },
  },
};

export const letter = {
  initial: { scaleY: 0, y: 50, x: -30, opacity: 0.5 },
  animate: {
    scaleY: 1,
    y: 0,
    x: 0,
    opacity: 1,
  },
};

export const pageCurtainAnime = {
  initial: { width: "100%" },
  animate: {
    width: "0%",
    transition: {
      duration: 3,
      delay: 1,
      ease: "easeInOut",
    },
  },
};
export const curtainLogoAnime = {
  initial: { opacity: 1 },
  animate: {
    opacity: 0.8,
    transition: {
      duration: 3,
      delay: 1,
      ease: "easeInOut",
    },
  },
};

export const ingredientEntryExit = {
  initial: { opacity: 0, scale: 0.5 },
  animate: (i = 0) => ({
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
      delay: i * 0.1, // dynamic delay per index
    },
  }),
  exit: {
    opacity: 0,
    scale: 0.5,
    transition: { duration: 0.3 },
  },
};

export const elementsEntryExit = {
  initial: { opacity: 0, scale: 0.5 },
  animate: {
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.5,
    transition: { duration: 0.3 },
  },
};

export const characterInactive = {
  initial: { scale: 1 },
  animate: {
    scale: 0.9,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 20,
    },
  },
  exit: {
    scale: 1,
    transition: { duration: 0.3 },
  },
};
